import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createGlobalStyle } from "styled-components";
import { Button } from "reactstrap";

import logo from "assets/images/heylime-logo.png";
import { setIsLoading } from "redux/loader/action";

const LaunchController = (props) => {
  const dispatch = useDispatch();
  const gameData = useSelector(
    (state) => state.gameReducer.gamesData.onboarding
  );
  let allParams = gameData?.phone;

  useEffect(() => {
    dispatch(setIsLoading(false));
  }, []);

  return (
    <>
      <GlobalStyle />
      <div className="game-select-head">
        <img onClick={() => props.history.push("/")} src={logo} alt="logo" />
        <div className="toggleWrapper">
          <a href={gameData?.play_laterURL} target="_blank">
            {gameData?.play_later_text}
          </a>
        </div>
      </div>
      <div className="game-select">
        <div className="game-select-LaunchController">
          <div className="text-center">
            <img src={allParams.imageURL} className="computer" alt="computer" />
          </div>
          <div className="text-center">
            <h2>{allParams.label_1}</h2>
            <p>
              {allParams.text_1}
              <br />
              <p className="shareLink">
                {allParams.link_text}
                <img src={allParams.shareURL} alt="link" />
              </p>
            </p>
            <p>{allParams.text_2}</p>
            <h2>{allParams.label_2}</h2>
            <p>{allParams.text_3}</p>
          </div>
          <div className="text-center">
            <Button
              color="LaunchController"
              onClick={() => window.open(allParams.launch_url)}
            >
              {allParams.launch_text}
            </Button>
          </div>
          <p className="bottom-text">{allParams.text_4}</p>
        </div>
      </div>
    </>
  );
};

export default LaunchController;

const GlobalStyle = createGlobalStyle`
  .game-select {
    @media (max-width: 575.98px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .game-select-head {
    position: relative;

    .toggleWrapper {
      position: absolute;
      top: 50%;
      right: 113px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;

      @media (min-width: 1700px) {
        right: 123px;
      }

      a {
        font-family: 'Helvetica Neue';
        color: #fff !important;
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
      }
    }
  }

  .logout-btn {
    top: 10px !important;
    right: 35px !important;

    @media (max-width: 1199.98px) {
      right: 25px !important;
    }

    @media (max-width: 767.98px) {
      display: none;
    }

    @media (max-width: 575.98px) {
      top: 20px !important;
      right: 10px !important;

      button {
        font-size: 0;

        img {
          margin-right: 0 !important;
        }
      }
    }
  }
`;
